module.exports = __webpack_public_path__ + "img/iconenglish.bc55b563.png";